import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  return (
    <div className="home">
      <section className="hero">
        <h1>Welcome to Mumbai Slang Translator!</h1>
        <p className="hero-subtitle">
          Your AI-powered translator to understand Mumbai's unique slang, 
          street language, and local expressions like a true Mumbaikar.
        </p>
      </section>

      <section className="services">
        <h2>Understand Mumbai Like a Local</h2>
        <div className="service-grid">
          <Link to="/translate" className="service-card featured">
            <div className="service-icon">🗣️</div>
            <h3>Mumbai Slang Translator</h3>
            <p>
              Decode Mumbai's unique slang, tapori language, and street expressions. 
              From "bhidu" to "jhakaas" - understand what locals really mean!
            </p>
            <div className="service-examples">
              <span className="example">"Kya scene hai?"</span>
              <span className="example">"Bhidu"</span>
              <span className="example">"Jhakaas"</span>
            </div>
          </Link>
        </div>
      </section>

      <section className="features">
        <h2>Why Use Our Mumbai Slang Translator?</h2>
        <div className="feature-list">
          <div className="feature-item">
            <h4>🎯 Authentic Mumbai Context</h4>
            <p>Real Mumbai slang with cultural context, not generic translations</p>
          </div>
          <div className="feature-item">
            <h4>🌐 Works Offline</h4>
            <p>Access translations even when you're offline</p>
          </div>
          <div className="feature-item">
            <h4>📱 Mobile Friendly</h4>
            <p>Perfect for on-the-go translation while exploring Mumbai</p>
          </div>
          <div className="feature-item">
            <h4>⚡ Instant Results</h4>
            <p>Quick translations with confidence scores and alternatives</p>
          </div>
        </div>
      </section>

      <section className="popular-slang">
        <h2>Popular Mumbai Slang</h2>
        <div className="slang-preview">
          <div className="slang-item">
            <strong>Bhidu</strong> - Friend/Buddy
          </div>
          <div className="slang-item">
            <strong>Jhakaas</strong> - Awesome/Fantastic
          </div>
          <div className="slang-item">
            <strong>Tapri</strong> - Small tea stall
          </div>
          <div className="slang-item">
            <strong>Scene</strong> - Situation/Plan
          </div>
          <div className="slang-item">
            <strong>Solid</strong> - Very good/Excellent
          </div>
          <div className="slang-item">
            <strong>Bindaas</strong> - Carefree/Awesome
          </div>
        </div>
        <Link to="/translate" className="cta-button">
          Start Translating →
        </Link>
      </section>
    </div>
  );
};

export default Home;